import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';

const MONTHS = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
const YEARS = [2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031];

class FilterDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilterDropdown: false,
            showCSNameDropdown: false,
            showPeriodDropdown: false,
            showMonthDropdown: false,
            showYearDropdown: false,
            selectedMonth: '',
            selectedYear: '',
            dataCS: {
                data: [],
                value: [],
                selected: []
            },
        }
    }

    handleOpenFilterDropDown = () => {
        this.setState({
            showFilterDropdown: !this.state.showFilterDropdown
        })
    }

    handleCloseAllFilter = () => {
        this.setState({
            showFilterDropdown: false,
            showCSNameDropdown: false,
            showPeriodDropdown: false,
            showMonthDropdown: false,
            showYearDropdown: false,
        });
        let selectedMonth = MONTHS.indexOf(this.state.selectedMonth) + 1;
        if (selectedMonth === 0) selectedMonth = '';
        this.props.handleFilter(this.state.dataCS.selected, selectedMonth, this.state.selectedYear);
    }

    handleOpenCSNameDropDown = async () => {
        await this.setState({
            dataCS: {
                ...this.state.dataCS,
                data: this.props.dataCSName
            }
        })

        this.setState({
            showCSNameDropdown: !this.state.showCSNameDropdown
        })
    }

    handleOpenPeriodDropDown = async () => {
        await this.setState({
            selectedMonth: MONTHS[this.props.month - 1],
            selectedYear: this.props.year
        })

        this.setState({
            showPeriodDropdown: !this.state.showPeriodDropdown
        })
    }

    handleOpenSelectMonth = () => {
        this.setState({
            showMonthDropdown: !this.state.showMonthDropdown
        })
    }

    placeholderMonth = () => {
        if (this.state.selectedMonth) {
            return this.state.selectedMonth;
        }
        return 'Bulan';
    }

    handleClearSelectMonth = () => {
        this.setState({
            selectedMonth: '',
        }, () => {
            this.setState({
                showMonthDropdown: false,
            });
        })
    }

    handleOpenSelectYear = () => {
        this.setState({
            showYearDropdown: !this.state.showYearDropdown
        })
    }

    placeholderYear = () => {
        if (this.state.selectedYear) {
            return this.state.selectedYear;
        }
        return 'Tahun';
    }

    handleClearSelectYear = () => {
        this.setState({
            selectedYear: '',
        }, () => {
            this.setState({
                showYearDropdown: false,
            });
        })
    }

    handleChangeCSName = data => {
        this.setState({
            dataCS: {
                ...this.state.dataCS,
                selected: data.map(data => ({ 'data_id': data.value })),
                value: data
            }
        })
    }

    handleFilterCSName = (option, inputValue) => {
        return option.label.toLowerCase().includes(inputValue.toLowerCase());
    }

    handleClearAll = () => {
        this.setState({
            dataCS: {
                ...this.state.dataCS,
                value: [],
                selected: []
            }
        }, () => {
            this.props.handleResetFilter();
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.month !== this.props.month) {
            this.setState({ selectedMonth: MONTHS[this.props.month - 1] })
        }
        if (prevProps.year !== this.props.year) {
            this.setState({ selectedYear: this.props.year })
        }
    }

    render() {
        return (
            <div className="relative font-medium select-none" >
                <div className="flex justify-between items-center bg-white h-10 p-2 rounded shadow-box-button cursor-pointer" onClick={this.handleOpenFilterDropDown}>
                    <div>Filter</div>
                    {this.state.showFilterDropdown ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                </div>
                <div className={this.state.showFilterDropdown ? "absolute w-full top-14 bg-white z-10 pb-6 rounded shadow-box-button" : "hidden"}>
                    {/* CS Name Tidak ada pada CS Officer dan Principal*/}
                    {
                        (this.props.userCategory === 'manager' || this.props.userCategory === 'lead') &&
                        <div id="ddscsname" className="flex justify-between items-center cursor-pointer p-2" onClick={this.handleOpenCSNameDropDown}>
                            <div> Nama CS </div>
                            {this.state.showCSNameDropdown ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                        </div>
                    }
                    {/* CS Name Content Tidak ada pada CS Officer dan Principal*/}
                    <div className={this.state.showCSNameDropdown ? "bg-blue-200 w-full" : "hidden"}>
                        <div className="h-auto p-2">
                            <Select
                                closeMenuOnSelect={false}
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                isMulti
                                placeholder="Cari Nama CS"
                                options={this.state.dataCS.data}
                                value={this.state.dataCS.value}
                                onChange={this.handleChangeCSName}
                                filterOption={this.handleFilterCSName}
                                menuIsOpen
                                maxMenuHeight={"14rem"}
                            />
                            <div className="h-60">
                                <br />
                            </div>
                        </div>
                    </div>
                    {/* Period */}
                    <div id="btnperiode" className="flex justify-between items-center cursor-pointer p-2" onClick={this.handleOpenPeriodDropDown} >
                        <div> Periode </div>
                        {this.state.showPeriodDropdown ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                    </div>
                    {/* Period Content */}
                    <div className={this.state.showPeriodDropdown ? "bg-blue-200 w-full p-2 flex" : "hidden"}>
                        {/* Select Month */}
                        <div className="w-1/2 pr-1">
                            <div id="ddlmonth" className="flex items-center justify-between bg-white h-10 p-2 rounded shadow-box-button cursor-pointer" onClick={this.handleOpenSelectMonth}>
                                <div className="flex justify-between w-10/12">
                                    <div> {this.placeholderMonth()} </div>
                                    {this.state.selectedMonth !== "" ?
                                        <FontAwesomeIcon icon={faTimes} className="fa-lg text-gray-300 hover:text-gray-400 border-r border-gray-300 pr-1" onClick={this.handleClearSelectMonth} />
                                        :
                                        <FontAwesomeIcon icon={faTimes} className="opacity-0" />
                                    }
                                </div>
                                {this.state.showMonthDropdown ?
                                    <FontAwesomeIcon className="-mt-1" icon={faChevronUp} />
                                    :
                                    <FontAwesomeIcon className="-mt-1" icon={faChevronDown} />
                                }
                            </div>
                            <div className={this.state.showMonthDropdown ? "mt-2 bg-white rounded shadow-box-button overflow-auto h-40" : "hidden"}>
                                {MONTHS.map((month, index) => {
                                    return (
                                        <div className="hover:bg-blue-100 px-3 py-1 cursor-pointer" key={`filter-months-${index}`} onClick={() => this.setState({ selectedMonth: month, showMonthDropdown: false })}>{month}</div>
                                    )
                                })}
                            </div>
                        </div>
                        {/* Select Year */}
                        <div className="w-1/2 pl-1">
                            <div id="ddlyear" className="flex items-center justify-between bg-white h-10 p-2 rounded shadow-box-button cursor-pointer" onClick={this.handleOpenSelectYear}>
                                <div className="flex justify-between w-10/12">
                                    <div> {this.placeholderYear()} </div>
                                    {this.state.selectedYear !== "" ?
                                        <FontAwesomeIcon icon={faTimes} className="fa-lg text-gray-300 hover:text-gray-400 border-r border-gray-300 pr-1" onClick={this.handleClearSelectYear} />
                                        :
                                        <FontAwesomeIcon icon={faTimes} className="opacity-0" />
                                    }
                                </div>
                                {this.state.showYearDropdown ?
                                    <FontAwesomeIcon className="-mt-1" icon={faChevronUp} />
                                    :
                                    <FontAwesomeIcon className="-mt-1" icon={faChevronDown} />
                                }
                            </div>
                            <div className={this.state.showYearDropdown ? "select-none mt-2 bg-white rounded shadow-box-button overflow-auto h-40" : "hidden"}>
                                {YEARS.map((year, index) => {
                                    return (
                                        <div className="hover:bg-blue-100 px-3 py-1 cursor-pointer" key={`filter-year-${year}`} onClick={() => this.setState({ selectedYear: year, showYearDropdown: false })}>{year}</div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end pt-5 px-2">
                        <button id="btnreset" className="bg-white border border-blue-500 rounded text-blue-500 py-2 px-5 font-medium" onClick={this.handleClearAll}>Reset</button>
                        <button id="btnapply" className={(this.state.selectedMonth !== '' && this.state.selectedYear === '' ? "bg-darkgrey cursor-not-allowed" : "bg-lightblue") + " ml-4 rounded text-white py-2 px-5 font-medium"} disabled={this.state.selectedMonth !== '' && this.state.selectedYear === ''} onClick={this.handleCloseAllFilter}>Terapkan</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default FilterDashboard;